import Pagination from "../../../shared/components/pagination/pagination"
import PropertyCard from "../../../shared/components/property_card/property_card"

function PropertiesList({ gfilter, setgfilter, properties, propertiesError, countPage, page, setPage }) {
  return (
    <>
      {propertiesError ? (
        <div className="col-12 col-md-12">
          <img src="https://cdn.homierent.com/strapi-media/no_results_6ac70893fe.svg" width="300px" />
          <p style={{ marginTop: '32px', fontSize: '24px', fontFamily: 'Helvetica Now Display, sans-serif' }}>{propertiesError}</p>
        </div>)
        :
        <>
          <div className="row">
            {properties.all
              .data?.filter((property) => property.price.value > 0 && property.price.value !== '')
              .map(property => {
                return (
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12" key={property.id}>
                    <PropertyCard gfilter={gfilter} property={property} />
                  </div>
                )
              })}
          </div>
          <Pagination countPage={countPage} page={page} setPage={setPage} gfilter={gfilter} setgfilter={setgfilter} />
        </>
      }
    </>
  )
}

export default PropertiesList
